module.exports = __webpack_public_path__ + "essentialSkills-7aa1afce65a8c27f23e381ab4ca2022e.svg";